export default __webpack_public_path__ + "static/media/Setting_Dreamless.975e172a.png";